module.exports = __webpack_public_path__ + "img/reports-backdrop-mobile.a72f1116.jpg";